export default "__VITE_ASSET__CyjSOmc___"